import { useDispatch, useSelector } from 'react-redux';
import { ConnectedEditDialogForm } from '@mews-commander/legacy-form';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { closeDialog } from '../../../../../modules/dialog/reducer';
import { isDialogOpen } from '../../../../../modules/dialog/selectors';
import { PRINT_BILL_MODAL_NAME as name } from '../Action/PrintFinancialDocumentAction';
import PrintBillModalDialogForm from './PrintBillModalDialogForm';

export const PrintBillModalDialog = () => {
    const dispatch = useDispatch();
    const active = useSelector((state: ApplicationState) => isDialogOpen(state, { name }));

    const onClose = () => dispatch(closeDialog(name));

    return (
        <ConnectedEditDialogForm
            active={active}
            formName={name}
            primaryButtonTextKey={TextKey.Print}
            closeDialog={onClose}
            title={<LocalizedText textKey={TextKey.Print} />}
        >
            <PrintBillModalDialogForm />
        </ConnectedEditDialogForm>
    );
};
